export default __webpack_public_path__ + "static/media/JPLogo.5a2ebae2.svg";